import { configureRequest, replacePathVariables } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { getUserRoleForBackend } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import { ConfirmTransferRequest, ConfirmTransferSuccessResponse } from './confirmTransfer.types'

export const confirmTransferApi = async (request: ConfirmTransferRequest): Promise<ConfirmTransferSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.logisticsPartner.confirmTransfer, { orderId: request.orderId }),
    method: 'POST',
    data: {
      logisticsPartnerId: request.logisticsPartnerId,
      notes: request.notes || null
    },
    headers: {
      'X-User-Role': getUserRoleForBackend()
    }
  })

  return response as ConfirmTransferSuccessResponse
}
